import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputCustomEvent, IonicModule } from '@ionic/angular';
import { FormsModule, ValidationErrors } from '@angular/forms';
import { CustomValidatorModule } from 'ngx-zcs-components';
import { InverterContentType, InverterSettingsCodeV2, InverterSettingsCodeV3, InverterSettingsCodeV4 } from 'ngx-modbus';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule }      from '@angular/material/input';
import { MatSelectModule }     from '@angular/material/select';
import { MatButtonModule }     from '@angular/material/button';

interface FieldData {
  value: InverterContentType | undefined | null;
  constraint: any;
  type: 'input' | 'select' | 'custom' | 'trigger';
  inputType?: string;
  hide?: boolean;
  submit: string;
}

export interface GlobalSettingItemData {
  name: string;
  key: string;
  code: InverterSettingsCodeV3 | InverterSettingsCodeV2 | InverterSettingsCodeV4;
  order: number;
  field: FieldData;
}

const FromStringToNumber = (value: string | null | undefined): number | null => {
  if (value === null || value === undefined) {
    return null;
  }
  return Number(value);
};

const trackByCode = (_: number, item: GlobalSettingItemData) => item.code;

@Component({
  standalone: true,
  imports: [
    CommonModule,
    CustomValidatorModule,
    FormsModule,
    IonicModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
  ],
  selector: 'app-global-setup',
  templateUrl: './global-setup.component.html',
  styleUrls: ['./global-setup.component.scss'],
})
export class GlobalSetupComponent implements OnInit {
  @Input() data: GlobalSettingItemData[] = [];
  @Output() action = new EventEmitter<{
    code: InverterSettingsCodeV3 | InverterSettingsCodeV2 | InverterSettingsCodeV4;
    value?: any;
    key: string;
  }>();

  @Input() mode: 'ionic' | 'material' = 'ionic';

  tempData: Record<string, FieldData> = {};
  submitDisabled = false;
  readonly trackByFn = trackByCode;

  ngOnInit(): void {
    this.data.forEach((item) => {
      this.tempData[item.key] = { ...item.field };
    });
  }

  onInputChange(validationErrors: ValidationErrors | null, input: InputCustomEvent, itemKey: string) {
    this.submitDisabled = !!validationErrors;
    this.tempData[itemKey].value = FromStringToNumber(input.detail.value);
  }

  onChange(item: GlobalSettingItemData, value: string | number | null) {
    this.tempData[item.key].value = value;
  }

  isSameValue(key: string): boolean {
    const item = this.data.find((x) => x.key === key);
    if (item) {
      return this.tempData[key].value === item.field.value;
    }
    return false;
  }
}
